import React, { Component } from 'react'
import { connect } from 'react-redux'
import { change } from 'redux-form'
import { History } from 'history'

import { parseQueryForDisplay, stringifyQuery } from '../../helpers/queryHelper'
import { selectAdminUserList } from '../../reducers/adminUsers'
import { fetchAdminList } from '../admin/adminActions'

import TaskFilterForm from './taskFilterForm'
import { selectCurrentUserBadges } from '../../reducers'

import { User } from '../../core/types'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  adminUsers: User[]
  fetchAdminList: Callback
  currentUserBadges: string[]
  change: Callback
  history: History
  location: Location
}

export class TaskFilter extends Component<Props> {
  static displayName = 'TaskFilter'

  componentWillMount() {
    const { fetchAdminList } = this.props
    fetchAdminList()
  }

  onSubmit = (values) => {
    const { history } = this.props
    const withDefaults = Object.assign({}, values, {
      offset: 0,
      limit: 25,
    })
    history.push({
      pathname: '/tasks',
      search: stringifyQuery(withDefaults),
    })
  }

  cancel = () => {
    const {
      history,
      location: { search },
    } = this.props
    history.push({
      pathname: '/tasks',
      search,
    })
  }

  destroy = () => {
    const {
      change,
      history,
      location: { search },
    } = this.props
    const valueArray = Object.keys(parseQueryForDisplay(search))
    valueArray.forEach((value) => {
      change('taskFilterForm', value, null)
    })
    history.push({
      pathname: '/tasks',
    })
  }

  initialValues = () => {
    const { location } = this.props
    return parseQueryForDisplay(location.search)
  }

  render() {
    const { adminUsers, currentUserBadges } = this.props
    return (
      <div className="index-task-filter">
        <h1 className="index-filter__header">Task Filters</h1>
        <TaskFilterForm
          onSubmit={this.onSubmit}
          initialValues={this.initialValues()}
          adminUsers={adminUsers}
          cancel={this.cancel}
          clear={this.destroy}
          currentUserBadges={currentUserBadges}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    adminUsers: selectAdminUserList(state.adminUsers),
    currentUserBadges: selectCurrentUserBadges(state),
  }
}

export default connect(mapStateToProps, {
  fetchAdminList,
  change,
})(TaskFilter)
